<p>vehicle-segment-options-detail works!</p>
